module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [(!this.minimal) ? _c('h1', [_c('small', [_vm._v("Van:")]), _vm._v(" " + _vm._s(_vm.username(_vm.teacher)))]) : _vm._e(), (_vm.compliments.length) ? _c('div', {
    staticClass: "feedback-compliments"
  }, [_c(_vm.heading, {
    tag: "component"
  }, [_vm._v("Dit heb je goed gedaan")]), _c('ul', _vm._l((_vm.compliments), function(compliment) {
    return _c('li', [_vm._v(_vm._s(compliment.content))])
  }))], 1) : _vm._e(), (_vm.remarks.length) ? _c('div', {
    staticClass: "feedback-remarks"
  }, [_c(_vm.heading, {
    tag: "component"
  }, [_vm._v("Besteed hier nog wat aandacht aan")]), _c('ul', _vm._l((_vm.remarks), function(remark) {
    return _c('li', [_vm._v(_vm._s(remark.content))])
  }))], 1) : _vm._e(), (_vm.feedback.content) ? _c('div', {
    staticClass: "feedback-comments"
  }, [_c(_vm.heading, {
    tag: "component"
  }, [_vm._v("Opmerkingen")]), _c('p', {
    staticClass: "preformatted"
  }, [_vm._v(_vm._s(_vm.feedback.content))])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fac9e338","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/presenters/TeacherFeedback.vue
// module id = F/CF
// module chunks = 1